import { useRef, useContext, useEffect } from "react";
import { Context } from "../store/reducer";

const Slider = () => {
    const { state, dispatch } = useContext(Context);
    const intervalId = useRef();
    const timeIdxRef = useRef();
    timeIdxRef.current = state.timeIdx;


    // 1度だけ実行する
    useEffect(()=>{

        /*
         * スライダーの初期位置を決定する
         * スライダーは複数のメニューで時刻が共通なので最初に取得できたものを使うシンプルな構造である。
         */
        
        let oneItem;
        
        if (state["vis_32"] && state["vis_32"].checked && Object.keys(state["vis_32"].data).length > 0) {
            oneItem = state["vis_32"].data[Object.keys(state["vis_32"].data)[0]];
        } else if (state["vis_34"] && state["vis_34"].checked && Object.keys(state["vis_34"].data).length > 0) {
            oneItem = state["vis_34"].data[Object.keys(state["vis_34"].data)[0]];
        } else if (state["vis_36"] && state["vis_36"].checked && Object.keys(state["vis_36"].data).length > 0) {
            oneItem = state["vis_36"].data[Object.keys(state["vis_36"].data)[0]];
        } else if (state["vis_38"] && state["vis_38"].checked && Object.keys(state["vis_38"].data).length > 0) {
            oneItem = state["vis_38"].data[Object.keys(state["vis_38"].data)[0]];
        } else if (state["vis_39"] && state["vis_39"].checked && Object.keys(state["vis_39"].data).length > 0) {
            oneItem = state["vis_39"].data[Object.keys(state["vis_39"].data)[0]];
        } else {
            return;
        }
        
        const lineCount = Object.keys(oneItem.rain_list).length - 1;

        dispatch({
            type: 'SET_TIME_IDX',
            payload: Number(lineCount)
        });
        
    },[]);

    let oneItem;
    
    // スライダーは複数のメニューで時刻が共通なので最初に取得できたものを使うシンプルな構造である。
    if (state["vis_32"] && state["vis_32"].checked && Object.keys(state["vis_32"].data).length > 0) {
        oneItem = state["vis_32"].data[Object.keys(state["vis_32"].data)[0]];
    } else if (state["vis_34"] && state["vis_34"].checked && Object.keys(state["vis_34"].data).length > 0) {
        oneItem = state["vis_34"].data[Object.keys(state["vis_34"].data)[0]];
    } else if (state["vis_36"] && state["vis_36"].checked && Object.keys(state["vis_36"].data).length > 0) {
        oneItem = state["vis_36"].data[Object.keys(state["vis_36"].data)[0]];
    } else if (state["vis_38"] && state["vis_38"].checked && Object.keys(state["vis_38"].data).length > 0) {
        oneItem = state["vis_38"].data[Object.keys(state["vis_38"].data)[0]];
    } else if (state["vis_39"] && state["vis_39"].checked && Object.keys(state["vis_39"].data).length > 0) {
        oneItem = state["vis_39"].data[Object.keys(state["vis_39"].data)[0]];
    } else {
        return <></>;
    }
    
    let labels = [];

    let ret = []

    let liStr = [];
    
    
    Object.keys(oneItem.rain_list).map(key => {

        const rainData = oneItem.rain_list[key];

        labels.push(rainData.datetime);

        liStr.push(<li></li>);
    })
    
    const firstLi = labels[0];
    const lastLi = labels.pop();

    // iOSのSafariでハイフン繋ぎの時刻をDateに渡すとNanとなるので置換後に加工
    const dt = new Date(firstLi.replace(/-/g,"/"))
    const firstMonthStr = `${(dt.getMonth()+1)}/${dt.getDate()}`
    const firstDateStr = `${dt.getHours()}:${dt.getMinutes().toString().padStart(2, "0")}`

    const lastDt = new Date(lastLi.replace(/-/g,"/"))
    const lastMonthStr = `${lastDt.getMonth()+1}/${lastDt.getDate()}`
    const lastDateStr = `${lastDt.getHours()}:${lastDt.getMinutes().toString().padStart(2, "0")}`


    const step    = 1;
    const stepMax = labels.length;
    
    const handleChange = (e) => {
        
        // console.log(e.target.value);
        
        // dispatch({
        //     type: 'SET_CURRENT_POPUP',
        //     payload: state.popups[Number(e.target.value)]
        // });
        
        dispatch({
            type: 'SET_TIME_IDX',
            payload: Number(e.target.value)
        });
    }

    function startAnimation() {
        if (state.playAnimation) {
            dispatch({
                type: 'SET_PLAY_ANIMATION',
                payload: !state.playAnimation
            });
            clearInterval(intervalId.current);
        } else {
            dispatch({
                type: 'SET_PLAY_ANIMATION',
                payload: !state.playAnimation
            });
            intervalId.current = setInterval(() => {
                if(timeIdxRef.current >= stepMax){
                    dispatch({
                        type: 'SET_PLAY_ANIMATION',
                        payload: !state.playAnimation
                    });
                    clearInterval(intervalId.current);
                  } else {
                    dispatch({
                        type: 'SET_TIME_IDX',
                        payload: state.timeIdx + step
                    });
                  }
            }, 1000);
        }
    }

    return (
        <main class="main">
        <div class="main-inner">
            <div className="slider-area">
                <div className="slider-inner">
                    <input className="slider" type="range" value={state.timeIdx} step={step} min="0" max={stepMax} onChange={(e)=>handleChange(e)}/>
                </div>
                <ul className="slider-memory">
                    {liStr}
                </ul>
                <ul className="slider-time">
                    <li>
                        <dl>
                            <dt>{firstMonthStr}</dt>
                            <dd>{firstDateStr}</dd>
                        </dl>
                    </li>
                    <li>
                        <dl>
                            <dt>{lastMonthStr}</dt>
                            <dd>{lastDateStr}</dd>
                        </dl>
                    </li>
                </ul>
            </div>
        </div>
    </main>
    )
}

export default Slider;
